import api from '@/helpers/api'

const API_READ = `/api/role/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ

export default {
    namespaced: true,
    state: {
        status: '',
        roles: [],
        currUser: {},
        errMessage: '',
        meta: {
            limit: 10,
            page: 1,
            total: 1
        },
        filter: {},
        search: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        read(state, { roles }) {
            state.roles = [...roles]
        },
        read_all(state, { roles }) {
            state.roles = [...roles]
        },
        read_single_success(state, { roles }) {
            state.roles = roles
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter };
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        clear_search(state) {
            state.search = {};
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        }
    },
    actions: {
        read({ commit, state }) {

            commit('request')

            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((result) => {
                        const roles = Object.keys(result.data.data).map(key => {
                            return {
                                id: key,
                                ...result.data.data[key]
                            };
                        });
                        commit('read', { roles: roles })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        commit('success')
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read_all({ commit }, corporate_id) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request("get", `${API_READ}${corporate_id}`)
                    .then((result) => {
                        // console.log(result.data.data);

                        const roles = Object.keys(result.data.data).map(key => {
                            return {
                                id: key,
                                ...result.data.data[key]
                            };
                        });
                        // console.log(result.data.data);

                        commit('read_all', { roles: roles })
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err.response.data);
                    });
            });
        },
        // eslint-disable-next-line no-unused-vars
        fetch_all_roles({ commit }, corporate_id) {
            return new Promise((resolve, reject) => {
                api.request("get", `${API_READ}${corporate_id}`)
                    .then((result) => {
                        const roles = Object.keys(result.data.data).map(key => {
                            return {
                                id: key,
                                ...result.data.data[key]
                            };
                        });
                        return resolve(roles);
                    }).catch((err) => {
                        return reject(err.response ? err.response.data : err);
                    });
            });
        },
        read_single({ commit }, { id, corporate_id }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request("get", `${API_READ}${id}/${corporate_id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err.response.data);
                    });
            });
        },
        delete({ commit, dispatch, state }, { name, corporate_id }) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.roles.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${name}/${corporate_id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success')
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err.response.data)
                    });
            });
        },
        reassign_users({ commit }, { from_role, to_role, corporate_id }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', `${API_READ}reassign-users`, {}, { from_role, to_role, corporate_id })
                    .then((response) => {
                        commit('success');
                        return resolve(response.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err.response?.data || err);
                    });
            });
        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                    .then(($request) => {
                        commit('success');
                        return resolve($request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        create({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });


        }
    },
    getters: {
        roles: () => state => state.roles,
    }
}
